import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import FormField from '../../shared/components/FormField';
import { I18nUtils } from '../../../i18n/I18nUtils';
import Row from '../../shared/components/Row';
import Well from '../../shared/components/Well';
import { connect } from 'react-redux';
import * as schemaTypeActions from '../../documents/actions/schemaTypeActions';
import { bindActionCreators } from 'redux';
import { Nif } from '../../shared/model/objectvalue/Nif';
import StateManager from '../../shared/utils/StateManager';
import debounce from 'lodash/debounce';
import LoadingView from '../../shared/components/LoadingView';
import * as importOutsource from '../actions/importOutsourceActions';
import { Name } from '../../shared/model/objectvalue/Name';
import { Password } from '../../shared/model/objectvalue/Password';
import { Email } from '../../shared/model/objectvalue/Email';
import { FormText } from '../../shared/components/FormText';
import { FormSwitch } from '../../shared/components/FormSwitch';
import { FormSubmit } from '../../shared/components/FormSubmit';
import { FormSelect } from '../../shared/components/FormSelect';

const FORM = {
    NAME: 'OutsourceForm',
    FIELDS: {
        OUTSOURCE_NIF: 'nif',
        OUTSOURCE_NAME: 'name',
        OUTSOURCE_CONTACT_PERSON: 'contact_person',
        OUTSOURCE_PHONE: 'phone',
        OUTSOURCE_EMAIL: 'email',
        OUTSOURCE_ADDRESS: 'address',
        OUTSOURCE_CCC: 'ccc',
        OUTSOURCE_ENABLED: 'enabled',
        CONTRACTOR_DOCUMENT_SCHEMA: 'document_schema_id',
        CONTRACTOR_DOCUMENT_SCHEMA_MONTHLY: 'document_schema_monthly_id',
        CONTRACTORS_MANAGER_EMAIL: 'user_email',
        CONTRACTORS_MANAGER_PASSWORD: 'user_password',
        SUBMIT: 'submit',
        ACTION: 'action',
    },
};

class OutsourceForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ...StateManager.getState(StateManager.OUTSOURCE_FORM),
            showLoader: false,
            isNifFieldInitialized: false,
        };
    }

    componentWillUnmount() {
        this.props.importOutsourceActions.clearSearchOutsource();
    }

    componentWillMount() {
        this.props.schemaTypeActions.getOutsourceDocumentSchemaState();
        this.props.schemaTypeActions.getOutsourceDocumentSchemaMontlyState();
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            change,
            addForm,
            importOutsource,
            searchOutsource,
        } = this.props;

        if ( addForm ) {
            if ( prevProps.importOutsource !== importOutsource ) {
                if ( importOutsource ) {
                    change(FORM.FIELDS.OUTSOURCE_NIF, importOutsource.cif);
                    change(FORM.FIELDS.OUTSOURCE_NAME, importOutsource.name);
                    change(FORM.FIELDS.OUTSOURCE_CONTACT_PERSON, '');
                    change(FORM.FIELDS.OUTSOURCE_PHONE, '');
                    change(FORM.FIELDS.OUTSOURCE_EMAIL, '');
                    change(FORM.FIELDS.OUTSOURCE_ADDRESS, '');
                    change(FORM.FIELDS.OUTSOURCE_CCC, '');
                    change(FORM.FIELDS.CONTRACTOR_DOCUMENT_SCHEMA, -1);
                    change(FORM.FIELDS.CONTRACTOR_DOCUMENT_SCHEMA_MONTHLY, -1);
                    change(FORM.FIELDS.OUTSOURCE_ENABLED, false);

                    this.onInitializeNifField(true);
                    this.onShowFormLoader(true);
                } else {
                    this.clearFields();
                }
            }

            if ( searchOutsource ) {
                if ( !prevProps.searchOutsource || prevProps.searchOutsource.id() !== searchOutsource.id() ) {
                    change(FORM.FIELDS.OUTSOURCE_NAME, searchOutsource.name());
                    change(FORM.FIELDS.OUTSOURCE_CONTACT_PERSON, searchOutsource.contactPerson());
                    change(FORM.FIELDS.OUTSOURCE_PHONE, searchOutsource.phone());
                    change(FORM.FIELDS.OUTSOURCE_EMAIL, searchOutsource.email());
                    change(FORM.FIELDS.OUTSOURCE_ADDRESS, searchOutsource.address());
                    change(FORM.FIELDS.OUTSOURCE_CCC, searchOutsource.ccc());
                    change(FORM.FIELDS.CONTRACTOR_DOCUMENT_SCHEMA, -1);
                    change(FORM.FIELDS.CONTRACTOR_DOCUMENT_SCHEMA_MONTHLY, -1);
                    change(FORM.FIELDS.OUTSOURCE_ENABLED, false);
                }
            } else {
                if ( prevProps.searchOutsource !== searchOutsource ) {
                    this.clearFields();
                }
            }
        }

        if ( prevProps.searchOutsourceLoading !== this.props.searchOutsourceLoading ||
            prevState.showLoader !== this.state.showLoader ) {
            const loading = this.props.searchOutsourceLoading || this.state.showLoader;
            this.props.changeLoading(loading);
        }
    }

    onInitializeNifField = (isNifFieldInitialized) => {
        this.setState({ isNifFieldInitialized });
    };

    onShowFormLoader = (showLoader) => {
        this.setState({ showLoader });
        if ( showLoader ) {
            setTimeout(() => this.onShowFormLoader(false), 1000);
        }
    };

    searchOutSource = (nif) => {
        const { isNifFieldInvalid } = this.props;
        if ( !isNifFieldInvalid ) {
            this.props.importOutsourceActions.searchOutsource(nif);
        }
    };

    onChangeNifField = (nif) => {
        const { isNifFieldInvalid } = this.props;

        if ( nif && !isNifFieldInvalid ) {
            this.onInitializeNifField(true);
            this.onShowFormLoader(true);
            this.searchOutSource(nif);
        } else {
            this.props.importOutsourceActions.clearSearchOutsource();
            this.clearFields();
        }
    };

    onChangeNifFieldDebounced = debounce(this.onChangeNifField, 1000);

    clearFields = () => {
        const { change } = this.props;
        change(FORM.FIELDS.OUTSOURCE_NAME, '');
        change(FORM.FIELDS.OUTSOURCE_CONTACT_PERSON, '');
        change(FORM.FIELDS.OUTSOURCE_PHONE, '');
        change(FORM.FIELDS.OUTSOURCE_EMAIL, '');
        change(FORM.FIELDS.OUTSOURCE_ADDRESS, '');
        change(FORM.FIELDS.OUTSOURCE_CCC, '');
        change(FORM.FIELDS.CONTRACTOR_DOCUMENT_SCHEMA, -1);
        change(FORM.FIELDS.CONTRACTOR_DOCUMENT_SCHEMA_MONTHLY, -1);
        change(FORM.FIELDS.OUTSOURCE_ENABLED, false);
    };

    renderField = (field) => <FormField field={field}/>;

    render() {
        const { isNifFieldInitialized, showLoader } = this.state;
        const {
            action,
            addForm,
            editable,
            onSubmit,
            outsource,
            handleSubmit,
            showAllFields,
            searchOutsource,
            allowChangeStatus = true,
            searchOutsourceLoading,
            outsourceDocumentSchemaType,
            outsourceDocumentSchemaMonthlyType,
        } = this.props;

        const canWrite = editable && ( !searchOutsource || searchOutsource.isActive() );
        const canDisable = !addForm && outsource && !outsource.is_also_contractor;

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <LoadingView loading={showLoader || searchOutsourceLoading}/>
                <Row>
                    <Field
                        col="col-md-6"
                        testId="form-nif"
                        label={I18nUtils.tr('TR_NIF')}
                        placeholder={I18nUtils.tr('TR_NUMERO_DE_IDENTIFICACION_FISCAL')}
                        name={FORM.FIELDS.OUTSOURCE_NIF}
                        disabled={!editable || showLoader}
                        component={FormText}
                        onChangeValueSideEffect={addForm ? this.onChangeNifFieldDebounced : undefined}
                    />
                    {
                        ( isNifFieldInitialized || showAllFields ) ? (
                            <Field
                                col="col-md-6"
                                testId="form-name"
                                label={I18nUtils.tr('TR_RAZON_SOCIAL')}
                                placeholder={I18nUtils.tr('TR_RAZON_SOCIAL')}
                                name={FORM.FIELDS.OUTSOURCE_NAME}
                                disabled={!canWrite}
                                component={FormText}
                            />
                        ) : null
                    }
                </Row>
                {
                    ( isNifFieldInitialized || showAllFields ) ? (
                        <React.Fragment>
                            <Row>
                                <Field
                                    col="col-md-6"
                                    testId="form-contact-person"
                                    label={I18nUtils.tr('TR_PERSONA_DE_CONTACTO')}
                                    placeholder={I18nUtils.tr('TR_PERSONA_DE_CONTACTO')}
                                    name={FORM.FIELDS.OUTSOURCE_CONTACT_PERSON}
                                    disabled={!canWrite}
                                    component={FormText}
                                />
                                <Field
                                    col="col-md-6"
                                    testId="form-phone"
                                    label={I18nUtils.tr('TR_TELEFONO')}
                                    placeholder={I18nUtils.tr('TR_NUMERO_DE_TELEFONO')}
                                    name={FORM.FIELDS.OUTSOURCE_PHONE}
                                    disabled={!canWrite}
                                    component={FormText}
                                />
                            </Row>
                            <Row>
                                <Field
                                    col="col-md-6"
                                    testId="form-email"
                                    label={I18nUtils.tr('TR_EMAIL_DE_SUBCONTRATA')}
                                    placeholder={I18nUtils.tr('TR_EMAIL_DE_SUBCONTRATA')}
                                    name={FORM.FIELDS.OUTSOURCE_EMAIL}
                                    disabled={!canWrite}
                                    component={FormText}
                                />
                                <Field
                                    col="col-md-6"
                                    testId="form-address"
                                    label={I18nUtils.tr('TR_DIRECCION')}
                                    placeholder={I18nUtils.tr('TR_DIRECCION')}
                                    name={FORM.FIELDS.OUTSOURCE_ADDRESS}
                                    disabled={!canWrite}
                                    component={FormText}
                                />
                            </Row>
                            <Row>
                                <Field
                                    col="col-md-6"
                                    testId="form-ccc"
                                    label={I18nUtils.tr('TR_CODIGO_CUENTA_COTIZACION_CCC')}
                                    placeholder={I18nUtils.tr('TR_CODIGO_CUENTA_COTIZACION_CCC')}
                                    name={FORM.FIELDS.OUTSOURCE_CCC}
                                    disabled={!canWrite}
                                    component={FormText}
                                />
                                {
                                    canDisable ? (
                                        <Field
                                            col="col-md-6"
                                            testId="form-enabled"
                                            name={FORM.FIELDS.OUTSOURCE_ENABLED}
                                            label={I18nUtils.tr('TR_ESTADO')}
                                            labelDisabled={I18nUtils.tr('TR_INACTIVA')}
                                            labelEnabled={I18nUtils.tr('TR_ACTIVA')}
                                            disabled={!canWrite && !allowChangeStatus}
                                            component={FormSwitch}
                                        />
                                    ) : null
                                }
                            </Row>
                            <Row>
                                <Field
                                    col="col-md-6"
                                    testId="form-contractor-document-schema"
                                    name={FORM.FIELDS.CONTRACTOR_DOCUMENT_SCHEMA}
                                    label={I18nUtils.tr('TR_ESQUEMA_DE_DOCUMENTOS')}
                                    options={outsourceDocumentSchemaType}
                                    component={FormSelect}
                                    disabled={!canWrite}
                                />
                                <Field
                                    col="col-md-6"
                                    testId="form-contractor-document-schema-monthly"
                                    name={FORM.FIELDS.CONTRACTOR_DOCUMENT_SCHEMA_MONTHLY}
                                    label={I18nUtils.tr('TR_ESQUEMA_DE_DOCUMENTOS_MENSUAL')}
                                    options={outsourceDocumentSchemaMonthlyType}
                                    component={FormSelect}
                                    disabled={!canWrite}
                                />
                            </Row>
                            {
                                !outsource && ( !searchOutsource || searchOutsource.isImported() ) ? (
                                    <Well>
                                        <Row>
                                            <div className="col-sm-12">
                                                <p className="lead">{I18nUtils.tr('TR_NUEVO_USUARIO')}</p>
                                            </div>
                                        </Row>
                                        <Row>
                                            <Field
                                                col="col-md-6"
                                                testId="form-contractors-manager-email"
                                                label={I18nUtils.tr('TR_EMAIL_DEL_USUARIO')}
                                                placeholder={I18nUtils.tr('TR_EMAIL_DEL_USUARIO')}
                                                name={FORM.FIELDS.CONTRACTORS_MANAGER_EMAIL}
                                                disabled={!canWrite}
                                                component={FormText}
                                            />
                                            <Field
                                                col="col-md-6"
                                                testId="form-contractors-manager-password"
                                                label={I18nUtils.tr('TR_CONTRASENA_DEL_USUARIO')}
                                                placeholder={I18nUtils.tr('TR_CONTRASENA')}
                                                name={FORM.FIELDS.CONTRACTORS_MANAGER_PASSWORD}
                                                disabled={!canWrite}
                                                component={FormText}
                                                password={true}
                                            />
                                        </Row>
                                    </Well>
                                ) : null
                            }
                            {
                                canWrite ? (
                                    <Row>
                                        <Field
                                            col="col-md-6 col-md-offset-6"
                                            label={I18nUtils.tr(outsource ? 'TR_GUARDAR' : 'TR_CREAR')}
                                            name={FORM.FIELDS.SUBMIT}
                                            component={FormSubmit}
                                        />
                                    </Row>
                                ) : null
                            }
                            {
                                action ? (
                                    <Row>
                                        <Field
                                            colWidth="col-md-6 col-md-offset-6"
                                            label={action.text.toUpperCase()}
                                            name="action"
                                            type="button"
                                            onClick={action.onClick}
                                            component={this.renderField}
                                        />
                                    </Row>
                                ) : null
                            }
                        </React.Fragment>
                    ) : null
                }
            </form>
        );
    }

}

function validate(values) {
    const {
        name,
        nif,
        user_email,
        user_password,
        document_schema_id,
    } = values;

    const errors = {};

    try {
        new Name(name);
    } catch (e) {
        errors.name = e.message;
    }

    try {
        new Nif(nif);
    } catch (e) {
        errors.nif = e.message;
    }

    try {
        new Email(user_email);
    } catch (e) {
        errors.user_email = e.message;
    }

    try {
        new Password(user_password);
    } catch (e) {
        errors.user_password = e.message;
    }

    if ( !document_schema_id || document_schema_id.length === 0 || document_schema_id === -1 ) {
        errors.document_schema_id = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }

    return errors;
}

OutsourceForm = reduxForm({
    validate,
    form: FORM.NAME,
    enableReinitialize: true,
})(OutsourceForm);

const mapStateToProps = (state, ownProps) => {
    const initialValues = { disabled: false, ...ownProps.outsource };

    if ( initialValues ) {
        initialValues.document_schema_id = initialValues.document_schema
            ? [{ value: initialValues.document_schema.id }]
            : [];

        initialValues.document_schema_monthly_id = initialValues.document_schema_monthly
            ? [{ value: initialValues.document_schema_monthly.id }]
            : [];

        initialValues.enabled = !initialValues.disabled;
    }

    const outsourceSchemaOptions = state.schemaType.outsourceDocumentSchemaType.map((schema) => {
        return {
            value: schema.id,
            name: schema.name,
        };
    });

    const outsourceSchemaMonthlyOptions = state.schemaType.outsourceDocumentSchemaMonthlyType.map((schema) => {
        return {
            value: schema.id,
            name: schema.name,
        };
    });

    const isNifFieldInvalid = !!(
        state.form['OutsourceForm'] &&
        state.form['OutsourceForm'].syncErrors &&
        state.form['OutsourceForm'].syncErrors.nif );

    return {
        initialValues,
        outsourceDocumentSchemaType: outsourceSchemaOptions,
        outsourceDocumentSchemaMonthlyType: outsourceSchemaMonthlyOptions,
        importOutsource: state.importOutsources.importOutsource,
        isNifFieldInvalid: isNifFieldInvalid,
        searchOutsource: state.importOutsources.searchOutsource,
    };
};

const mapDispatchToProps = dispatch => ( {
    importOutsourceActions: bindActionCreators(importOutsource, dispatch),
    schemaTypeActions: bindActionCreators(schemaTypeActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(OutsourceForm);

OutsourceForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    outsource: PropTypes.any,
    editable: PropTypes.bool,
    action: PropTypes.shape({
        text: PropTypes.string.isRequired,
        action: PropTypes.func.isRequired,
    }),
    showAllFields: PropTypes.bool,
    allowChangeStatus: PropTypes.bool,
    addForm: PropTypes.bool,
    changeLoading: PropTypes.func,
};

OutsourceForm.defaultProps = {
    onSubmit: () => {},
    editable: true,
    addForm: false,
    changeLoading: () => {},
};



// WEBPACK FOOTER //
// ./src/app/outsource/components/OutsourceForm.jsx